<div class="flex message_center_filter">
  <div class="flex-grow-1">
    <div class="message_center_filter__header-tab" [style.border-bottom]="getBorderWidth('open') +'px solid #206487'">
      <button
        mat-button
        (click)="setState('open')"
        class="message_center_filter__header-tab-button">
        <span class="message_center_filter__header-tab-button-text" [style.font-weight]="state === 'open' ? 'bold' : null">Open</span>
      </button>
    </div>
    <div class="message_center_filter__header-tab" [style.border-bottom]="getBorderWidth('closed') +'px solid #206487'">
      <button
        mat-button
        class="message_center_filter__header-tab-button custom-icon"
        [class.black-tab-button]="state === 'closed'"
        [class.grey-tab-button]="state !== 'closed'"
        (click)="setState('closed')">
        <span class="message_center_filter__header-tab-button-text" [style.font-weight]="state === 'closed' ? 'bold' : null">Closed</span>
      </button>
    </div>
  </div>
</div>
